module.exports = __webpack_public_path__ + "5261d2d33c3dc454c586054046f4bdd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/banner_cpim_still.jpg
// module id = 633
// module chunks = 0